import { fetch, fetchCore } from "data/controls"
import store from 'data/redux/store'
import { v4 as uuidv4 } from 'uuid'

window.uuid = uuidv4()

/* MESSAGES */

export const uiMessage = data => (dispatch, getState) => {  
  
  console.log(data)
}

/* App events */

export const UI_SAVE_NAVIGATOR_FIELDS = 'UI_SAVE_NAVIGATOR_FIELDS'
export const uiSaveNavigatorFields = data => (
  {
    type: UI_SAVE_NAVIGATOR_FIELDS,
    payload: {
      data: data
    }
  }
)

export const uiSendEventToAWS = eventdata => (dispatch, getState) => {

  const awsSendEvent = positionOrError => {

    const state = getState()

    let data = {}

    Object.keys(state.ui.navigatorfields)
          .forEach(key => (data[key] = state.ui.navigatorfields[key])) 

    data['sessionId'] = window.uuid  
    data['apptimestamp'] = new Date().getTime()

    if(
      positionOrError
      &&
      positionOrError.coords
    ) {

      data['latitude'] = positionOrError.coords.latitude    
      data['longitude'] = positionOrError.coords.longitude
    }

    data = {
      ...data,
      ...eventdata.data || {}
    }

    const fetchConfig = {
      method: 'POST',
      body: data
    }

    const gameid = eventdata.gameId || window.playmotiv.game?.gameId || 0
    const userid = window.playmotiv.user?.id 
    const url = `/game/${gameid}/${userid}/log/${eventdata.action}`

    fetch(url, fetchConfig)
  }

  if (document.location.search.indexOf('simulateUser=') > -1) { return }
  
  (window.playmotiv.player?.events?.sendlocation) ?
    ('geolocation' in navigator) ?
      navigator.geolocation.getCurrentPosition(awsSendEvent, awsSendEvent)
      :
      awsSendEvent({
        message: 'Geolocation not supported'
      })
    :
    awsSendEvent({
      message: 'Geolocation disabled'
    })
}

export const uiMenusLoad = action => (dispatch, getState) => {

  const state = getState()

  if (state.ui.menus) { return Promise.resolve() }

  return fetchCore('/contentmapsdata').then(result => dispatch(uiMenusLoaded(result)))
}

export const UI_MENUS_LOADED = 'UI_MENUS_LOADED'
export const uiMenusLoaded = data => ({ 
  type: UI_MENUS_LOADED,
  payload: data
})

export const UI_SET_CONTEXT = 'UI_SET_CONTEXT'
export const uiSetContext = data => (
  { 
    type: UI_SET_CONTEXT,
    payload: data
  }
)

export const loadWPContent = wpId => (dispatch, getState) => {

  const state = getState()
  
  return fetchCore(`/contents/${wpId}`)
  .then(result => { 

    if (!result.content) return
    
    const cleancontent = result.content.split('\n').join('')
    dispatch(wpContentLoaded(wpId, {
      ...result,
      content: cleancontent
    }))
  })
}

export const wpContentLoaded = (wpId, content) => {
  return {
    type: 'WP_CONTENT_LOADED',
    payload: {
      wpId,
      content
    }
  };
}

export const UI_NEWS_STATE_LOAD = 'UI_NEWS_STATE_LOAD'
export const uiNewsStateLoad = () => (
  { 
    type: UI_NEWS_STATE_LOAD
  }
)

export const uiNewsStateSet = data => (dispatch, getState) => {

  dispatch(uiSendEventToAWS({
    action: 'readnews',
    data: {
      newsId: data.id,
      newsTitle: data.title
    }
  }))

  dispatch(uiNewsStateSetted({
    id: data.id
  }))
}

export const UI_NEWS_STATE_SETTED = 'UI_NEWS_STATE_SETTED'
export const uiNewsStateSetted = data => (
  { 
    type: UI_NEWS_STATE_SETTED,
    payload: data
  }
)

